import * as React from 'react'

import { observer } from 'mobx-react'
import { classList } from 'react-classlist-helper'

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '~/client/src/shared/components/shadcn-ui/tooltip'

import { iconProps, ISetUpNavigationRowProps } from './commonConstants'

@observer
export default class SetUpNavigationRow extends React.Component<ISetUpNavigationRowProps> {
  public render() {
    const { projectSetUpPageStore, step, isShortVersion } = this.props

    const { page, getTitle, Icon } = step
    const title = getTitle()
    const isAllowed = projectSetUpPageStore.isAllowedToNavigate(page)
    const current = projectSetUpPageStore.currentPage === step.page

    return (
      <div
        onClick={this.navigateTo}
        className={classList({
          'navigation-row tw:flex tw:items-center py8 ml7 brada4 hoverable-page-bg': true,
          'current current-page-bg': current,
          pointer: isAllowed,
          h44: isShortVersion,
          'inactive-element': !isAllowed,
        })}
      >
        <Tooltip disabled={!isShortVersion}>
          <TooltipTrigger
            render={<span className="navigation-row-title row tw:flex-1" />}
          >
            <div
              className={classList({
                'no-grow': true,
                w32: isShortVersion,
                px8: !isShortVersion,
              })}
            >
              {Icon && <Icon {...iconProps} />}
            </div>
            <div className="title-text">{title}</div>
          </TooltipTrigger>
          <TooltipContent side="right" sideOffset={8}>
            {title}
          </TooltipContent>
        </Tooltip>
      </div>
    )
  }

  private navigateTo = () => {
    const { projectSetUpPageStore, step } = this.props
    projectSetUpPageStore.navigateTo(step.page)
  }
}
